import { useSelector } from "react-redux";
import DesignHubRepository from "src/repository/DesignHubRepository";
import { getCountryList, getCrossReferencePart } from "src/store/slice/model/DesignHub";
import store from "src/storeWire";


export function useDesignHubStore() {
    const countryList = useSelector((state) => state.entities.model_DesignHub.countryList)
    const crossReferencePartList = useSelector((state) => state.entities.model_DesignHub.crossReferenceParts)
    let data = {
        countryList,
        crossReferencePartList
    };

    let fetch = {
        get_country_list: async () => {
            return await store.dispatch(getCountryList())
        },
        get_cross_reference_parts: async (params) => {
            return await store.dispatch(getCrossReferencePart(params))
        }
    };
    let set = {
        register_user: async (params) => {
            return await new DesignHubRepository().registerUser(params);
        }

    };
    return [data, fetch, set]
}